export const TONES = {
  gold: { solid: "bg-[#C9962B] text-white", soft: "bg-[#C9962B]/12 text-[#8a6412] border-[#C9962B]/30", text: "text-[#C9962B]", ring: "ring-[#C9962B]/40", dot: "bg-[#C9962B]", hex: "#C9962B" },
  teal: { solid: "bg-teal text-white", soft: "bg-teal/10 text-teal border-teal/25", text: "text-teal", ring: "ring-teal/40", dot: "bg-teal", hex: "#0E7368" },
  violet: { solid: "bg-violet text-white", soft: "bg-violet/10 text-violet border-violet/25", text: "text-violet", ring: "ring-violet/40", dot: "bg-violet", hex: "#5B3B8C" },
  navy: { solid: "bg-[#1B2340] text-white", soft: "bg-[#1B2340]/10 text-[#1B2340] border-[#1B2340]/25", text: "text-[#1B2340]", ring: "ring-[#1B2340]/40", dot: "bg-[#1B2340]", hex: "#1B2340" },
  berry: { solid: "bg-berry text-white", soft: "bg-berry/10 text-berry border-berry/25", text: "text-berry", ring: "ring-berry/40", dot: "bg-berry", hex: "#A62F45" },
};

export const tone = (t) => TONES[t] || TONES.gold;

export const programTone = (label = "") => {
  const s = label.toLowerCase();
  if (s.includes("commerce") || s.includes("ipmat") || s.includes("cuet")) return "gold";
  if (s.includes("neet") || s.includes("bio")) return "teal";
  if (s.includes("jee") || s.includes("iit")) return "violet";
  return "berry";
};

export const programLabel = (t) => ({ gold: "Commerce", teal: "Science / NEET", violet: "IIT-JEE", berry: "Foundation" }[t] || t);
